import React from 'react';
import { PRODUCTIVITY_CATEGORY } from '@/utils/productivityAppClassifier';
import styles from './CategoryTag.module.scss';

const CATEGORY_CLASS_MAP = {
  [PRODUCTIVITY_CATEGORY.focus]: styles.focus,
  [PRODUCTIVITY_CATEGORY.distraction]: styles.distraction,
  [PRODUCTIVITY_CATEGORY.other]: styles.other,
};

export const CategoryTagComponent = ({ category }) => (
  <span
    className={`${styles.tag} ${CATEGORY_CLASS_MAP[category] || styles.other}`}
  >
    {category || PRODUCTIVITY_CATEGORY.other}
  </span>
);

CategoryTagComponent.displayName = 'CategoryTag';
